export enum EPlanPricing {
    ONBOARDING = 'onboarding',
    SUMERWEB = 'sumerweb'
}